import { IAtMentionUser, IPersonBase } from '@/api/types/response.types'
import { IAttachment } from '@/types/data-objects/attachments'

export interface IChronologyAction {
  id: number
  hasViewed: boolean
  createdOn: string
  createdOnEpochTime: number
  creator: IPersonBase
  action: string
}

export interface IChronologyComment {
  id: number
  canEdit: boolean
  isEdited: boolean
  hasViewed: boolean
  createdOn: string
  createdOnEpochTime: number
  creator: IPersonBase
  action: string
  description: string
  attachments: IAttachment[]
  mentionUsers: IAtMentionUser[]
}

export interface IChronologyCommentFormData {
  content: string
  fileList: IAttachment[]
  listAtMentionIDs?: number[]
  listFileUploadIDs?: number[]
  listRemovedAttachmentIDs?: number[]
}

export interface IChronologyReply {
  id: number
  canEdit: boolean
  isEdited: boolean
  hasViewed: boolean
  createdOn: string
  createdOnEpochTime: number
  creator: IPersonBase
  action: string
  description: string
  attachments: IAttachment[]
  ccs: string[]
  autoResponseSent: boolean
  stylizedHtmlVersionLink: string
  bounceInfo: IBounceInfo
}

export interface IBounceInfo {
  bouncedEmail: string
  description: string
  details: string
}

export enum IChronologyItemTypes {
  ACTION = 'action',
  COMMENT = 'comment',
  INTERNAL_COMMENT = 'internal-comment',
  REPLY_TO_CUSTOMER = 'reply-to-customer',
  REPLY_FROM_OUTSIDE_USER = 'reply-from-outside-user',
}

export interface IChronologyItem {
  type: IChronologyItemTypes
  data: IChronologyReply | IChronologyComment | IChronologyAction
}
